module.exports = __webpack_public_path__ + "media/img/Landing_Page/logos/21-4da4dd5ee386eeb3bb382abc6be41bd8.jpg";